export const hasInputErrors = (state) => {
  return Object.values(state.inputs).some((input) => input.error);
};

export const getPspByCode = (state) => (code) => {
  return state.psps.find((psp) => psp.code === code);
};

export const payInInstallments = (state) => {
  return state.selectedPaymentType === 'pay_in_installments';
};

export const selectedAmounts = (state, getters) => {
  if (getters.payInInstallments) {
    return state.amounts.firstRecurrencePayment;
  } else {
    return state.amounts.singlePayment;
  }
};

export const hasDifferentPriceForFirstPeriod = (state, getters) => {
  return getters.totalFirstRecurrenceDiscountedAmount != getters.totalRecurrenceDiscountedAmount;
};

export const hasDifferentLengthForFirstPeriod = (state) => {
  return state.productRecurrence.periodsMultiplier1 > 0;
};

export const hasTrial = (state, getters) => {
  return getters.hasDifferentPriceForFirstPeriod || getters.hasDifferentLengthForFirstPeriod;
};

export const isFreeForFirstPeriod = (state) => {
  return state.amounts.firstRecurrencePayment.discountedTotal.amountIncVat === 0;
};

export const isProductFreeForFirstPeriod = (state) => {
  return state.amounts.firstRecurrencePayment.product.amountIncVat === 0;
};

export const productAmount = (state) => {
  return getAmount(state, 'singlePayment', 'product');
};

export const productDiscountedAmount = (state) => {
  return getAmount(state, 'singlePayment', 'discountedProduct');
};

export const productFirstRecurrenceAmount = (state) => {
  return getAmount(state, 'firstRecurrencePayment', 'product');
};

export const productFirstRecurrenceDiscountedAmount = (state) => {
  return getAmount(state, 'firstRecurrencePayment', 'discountedProduct');
};

export const totalAmount = (state) => {
  return getAmount(state, 'singlePayment', 'total');
};

export const totalDiscountedAmount = (state) => {
  return getAmount(state, 'singlePayment', 'discountedTotal');
};

export const totalFirstRecurrenceAmount = (state) => {
  return getAmount(state, 'firstRecurrencePayment', 'total');
};

export const totalFirstRecurrenceDiscountedAmount = (state) => {
  return getAmount(state, 'firstRecurrencePayment', 'discountedTotal');
};

export const totalRecurrenceDiscountedAmount = (state) => {
  return getAmount(state, 'recurrencePayment', 'discountedTotal');
};

export const orderQuantity = (state) => {
  return parseInt(state.orderQuantity || 1);
};

export const getProductName = (state) => {
  return state.product.name.replace(/&amp;/g, '&');
};

export const getProductTitle = (state) => {
  return state.product.title.replace(/&amp;/g, '&');
};

function getAmount(state, paymentType, amountType) {
  return getFocusAmount(state, state.amounts[paymentType][amountType]);
}

function getFocusAmount(state, amounts) {
  return state.product.focusOnPriceExVat ? amounts.amountExVat : amounts.amountIncVat;
}
